import { module } from 'angular';
import component from './text-editor.component';
import nodeComponent from './nodes/node.component';

// Styles
// import 'prosemirror-menu/style/menu.css';
// import 'prosemirror-view/style/prosemirror.css';
import './text-editor.scss';

export default module('app.text-editor', [])
	.component('textEditor', component)
	.component('textEditorNode', nodeComponent)
	.name;
